import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

export interface DeleteUserReq {
  /** 验证码 */
  code?: string
}

@Injectable()
export class DeleteUserService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  deleteUser (data: DeleteUserReq) {
    return this.http.post('/team/account/cancel', data)
  }
}
